'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

import '@/components/Page/Page/Campaign/CampaignCard/CampaignCard.scss'
import { CardProps } from '@/components/Page/Page/Campaign/CampaignCard/CampaignCardLogic'

const CampaignCardLogic = dynamic(() => import('@/components/Page/Page/Campaign/CampaignCard/CampaignCardLogic'), {
  ssr: true,
})
const CampaignCard: FC<CardProps> = ({
  title,
  subTitle,
  description,
  href,
  src,
  width,
  height,
  className = '',
  nextLink = true,
}) => {
  return (
    <>
      <CampaignCardLogic
        title={title}
        subTitle={subTitle}
        description={description}
        href={href}
        src={src}
        width={width}
        height={height}
        className={className}
        nextLink={nextLink}
      />
    </>
  )
}

export default CampaignCard
